module.exports = __webpack_public_path__ + "static/media/Transformer.6c166461.png";